<template>
  <div class="flex-grow-1">
    <header-bar />
    <v-card
      elevation="0"
      color="#7c40dc"
      class="mb-10 mainCard"
      rounded="xl"
      height="600"
    >
      <v-img
        class="backgroundImage"
        src="/images/purpleSonar.png"
        width="100%"
        cover
      ></v-img>
      <v-container>
        <v-row>
          <v-col cols="6" class="ma-0 pa-4 cardContainer">
            <span class="sigflo-xl white--text">Contact Us</span>
            <v-card
              class="leftCard"
              color="white"
              width="550"
              height="320"
              rounded="xl"
            >
              <v-card-title class="text-center justify-center">
                <v-avatar color="#32ff99" size="64">
                  <v-img
                    class="elevation-6"
                    src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShaggyMullet&accessoriesType=Prescription01&hairColor=Black&facialHairType=MoustacheMagnum&facialHairColor=Black&clotheType=Hoodie&clotheColor=Blue01&eyeType=Happy&eyebrowType=RaisedExcitedNatural&mouthType=Smile&skinColor=Light"
                  ></v-img>
                </v-avatar>
              </v-card-title>
              <v-card-title
                class="contactTitle sigflo-h3 text-center justify-center"
                >Talk to our Sigflō experts</v-card-title
              >
              <v-card-text
                class="text-center justify-center sigflo-body textEmphasis cardText"
                >We can answer your Sigflō questions, help with order status or
                whatever you may need!
                <span class="purpleText">Hours: M-F 9AM - 4PM EST</span>
              </v-card-text>
              <v-card-actions class="text-center px-4">
                <v-btn
                  block
                  color="primary"
                  href="tel:+1-888-426-6155"
                  @click="handlePhoneClick"
                  ><v-icon class="mr-2">mdi-phone</v-icon>1-888-426-6155</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0 cardContainer">
            <v-img
              class="contactUsImage"
              src="/images/contactUs.jpg"
              height="600"
              cover
            ></v-img>
            <v-card
              class="rightCard"
              color="white"
              width="550"
              height="320"
              rounded="xl"
            >
              <v-card-title class="text-center justify-center">
                <v-avatar color="#7c40dc" size="64">
                  <v-img
                    class="elevation-6"
                    src="https://avataaars.io/?avatarStyle=Transparent&topType=LongHairNotTooLong&accessoriesType=Blank&hairColor=BrownDark&facialHairType=Blank&clotheType=Hoodie&clotheColor=Black&graphicType=Skull&eyeType=Side&eyebrowType=RaisedExcitedNatural&mouthType=Default&skinColor=Brown"
                  ></v-img>
                </v-avatar>
              </v-card-title>
              <v-card-title
                class="contactTitle sigflo-h3 text-center justify-center"
                >Send us an email!</v-card-title
              >
              <v-card-text
                class="text-center justify-center sigflo-body textEmphasis cardText"
                >If digital communication is more your speed, slide into our DMs
                (sorta)!</v-card-text
              >
              <v-card-actions class="text-center px-4">
                <v-btn
                  @click="handleEmailClick"
                  block
                  color="primary"
                  href="mailto:support@sigflo.com"
                  ><v-icon class="mr-2">mdi-email</v-icon
                  >support@sigflo.com</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <footer-bar />
  </div>
</template>

<script>
  import headerBar from '@/components/shared/HeaderBar.vue';
  import footerBar from '@/components/shared/FooterBar.vue';

  export default {
    components: {
      headerBar,
      footerBar
    }
  };
</script>

<style scoped>
  .mainCard {
    overflow: hidden;
  }
  .cardContainer {
    position: relative;
  }
  .contactUsImage {
    filter: brightness(60%) contrast(100%) grayscale(0%) sepia(0%);
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    opacity: 0.7;
  }
  .leftCard {
    position: absolute;
    right: 0;
    top: 150px;
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    box-shadow: none !important;
  }
  .rightCard {
    position: absolute;
    left: 0;
    top: 150px;
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
    border: 0px;
    box-shadow: none !important;
  }
  .cardText {
    min-height: 60px;
  }
  .backgroundImage {
    position: absolute;
    top: 0px;
    left: 0px;
  }
  .contactTitle {
    font-family: 'Neue Plak' !important;
  }
</style>
